import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";

import { useState } from "react";
import privateRequest from "../commonApi/CommonApi";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-google-places-autocomplete";
import { Helmet } from "react-helmet";
import Select from "react-select";
import moment from "moment";
import Swal from "sweetalert2";
import { Link, useNavigate, useParams } from "react-router-dom";
import MyCustomPlacesAutocomplete from "../CreateJob/Components/index";

function EditJob() {
  const suggestionsRef = useRef();
  const hasEffectRun = useRef(false);
  let addressd = localStorage.getItem("adres");
  const { data } = useParams();
  const [paramsData, setParamsData] = useState();
  const navigate = useNavigate();

  const inputRef = useRef(null);
  const [usersData, setUsersData] = useState();
  const [selectedGroup, setSelectedGroup] = useState();
  const [slotDates, setSlotDates] = useState();
  const [mobile, setMobile] = useState(paramsData?.userId?.mobileNo);
  const [name, setName] = useState(paramsData?.userId?.name);
  const [email, setEmail] = useState(paramsData?.userId?.email);
  const [combineData, setCombineData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [PCgroup, setPCgroup] = useState();
  const [slotData, setSlotData] = useState();
  const [slotsPreview, setSlotsPreview] = useState();
  const [otherCharges, setOtherCharges] = useState();
  const [services, setServices] = useState([]);
  const [concession, setConcession] = useState();
  const [selectedSlot, setselectedSlot] = useState("");
  const [fullAdress, setFullAdress] = useState();
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [selectedItem, setselectedItem] = useState();
  const [house, setHouse] = useState();
  const [apartment, setApartment] = useState();
  const [landmark, setLandmark] = useState();
  const [items, setItems] = useState([]);
  const [itemssss, setItemssss] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [source, setSource] = useState();
  const [surg, setSurg] = useState(0);
  const [itemRemoved, setItemRemoved] = useState(false);
  const [tip, setTip] = useState(0);
  const [couponValue, setcouponValue] = useState(0);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [slotLoading, setSlotLoading] = useState(false);
  const [createValid, setCreateValid] = useState(false);
  const [EditPackages, setEditPackages] = useState();

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handlePriceChange = (index, newPrice) => {
    const updatedCharges = otherCharges.map((item, i) =>
      i === index ? { ...item, price: newPrice } : item
    );
    setOtherCharges(updatedCharges);
  };
  let id = data;

  useEffect(() => {
    if (paramsData?.couponDiscount > 0) {
      setcouponValue(paramsData?.couponDiscount);
    }
  }, [paramsData]);

  const getUsers = async () => {
    try {
      const response = await privateRequest.get(`jobs/getJobsById/${id}`);

      setParamsData(response?.data?.data?.jobs[0]);

      let datt = response?.data?.data?.jobs[0];
      let group = {
        label: datt?.cart[0]?.PCGroup?.PCGName,
        value: datt?.cart[0]?.PCGroup?._id,
      };

      setMobile(datt?.userId?.mobileNo);
      setName(datt?.userId?.name);
      setEmail(datt?.userId?.email);
      handleGroupChange(group);
      setSelectedAddress(response?.data?.data?.jobs[0]?.clientAddress);
      setSource(response?.data?.data?.jobs[0]?.jobsSource);
      console.log(
        "response?.data?.data?.jobs[0]?.jobsSource",
        response?.data?.data?.jobs[0]?.jobsSource
      );
      setConcession(response?.data?.data?.jobs[0]?.concession);
      let a = response?.data?.data?.jobs[0]?.slotTime;
      // setselectedSlot(a);
      console.log(
        "response?.data?.data?.jobs[0]?.slotTime",
        response?.data?.data?.jobs[0]?.slotTime
      );
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  useEffect(() => {
    getUsers();
  }, [id]);

  useEffect(() => {
    if (paramsData) {
      setOtherCharges(paramsData?.otherCharges);
      setTip(paramsData?.tip);
      setselectedSlot(paramsData?.slotTime);
      if (paramsData?.slotDate) {
        setSelectedDate(paramsData?.slotDate);
      }
    }
  }, [paramsData]);

  const addRow = () => {
    setItemssss((prevItems) => [
      ...prevItems,
      {
        _id: prevItems.length,
        packageTitle: "",
        Quantity: 1,
        Amount: 0,
        id: "",
        packageTotalTime: 0,
        packagetotalPrice: 0,
        packageRegulerPrice: 0,
        type: "",
        PCGroup: "",
        value: "",
        PCatId: "",
      },
    ]);
  };

  const removeItem = (id) => {
    setItemssss(itemssss.filter((item) => item.value.value !== id));
    setItemRemoved(true);
  };
  const removePackage = (id) => {
    setEditPackages(EditPackages.filter((item) => item.id !== id));
    // setItemssss(itemssss.filter((item) => item.value.value !== id));

    // setItemRemoved(true);
  };
  console.log("EditPackages", EditPackages);
  useEffect(() => {
    if (itemRemoved) {
      getOtherCharges();
    }
  }, [itemRemoved]);

  const getAllDocumentData = async () => {
    try {
      const response = await privateRequest.get(`Service/CombineApis`);
      setCombineData(response?.data?.data);
      setPCgroup(response?.data?.data?.ParentGroup);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };
  const getUsersData = async () => {
    try {
      setLoading(true);
      // setAddresses();
      const response = await privateRequest.get(
        `Address/GetAddressByMobileNo/` + mobile
      );

      setUsersData(response?.data.data);
      setMobile(response?.data?.data[0]?.mobileNo);
      setEmail(response?.data?.data[0]?.email);
      setName(response?.data?.data[0]?.name);
      setAddresses(response?.data?.data[0]?.address);

      setLoading(false);
    } catch (error) {
      setLoading(false);

      console.error("Error fetching parent category groups:", error);
    }
  };

  useEffect(() => {
    if (mobile?.length == 10) {
      getUsersData();
    }

    if (mobile?.length < 10) {
      setEmail("");
      setName("");
      setAddresses("");
    }
  }, [mobile]);

  useEffect(() => {
    getAllDocumentData();
  }, []);

  let myApiKey = "AIzaSyCBRJgSZT50bFwgbOQHOWdi0giGUEdG3MY";

  let autocomplete;

  const componentForm1 = {
    street_number: "short_name",
    sublocality_level_1: "long_name",
    locality: "long_name",
    administrative_area_level_1: "long_name",
    country: "long_name",
    postal_code: "short_name",
  };

  useEffect(() => {
    initAutocomplete();
  }, []);

  const initAutocomplete = () => {
    autocomplete = new window.google.maps.places.Autocomplete(
      document.getElementById("search_location")
    );
    autocomplete.setComponentRestrictions({ country: ["in"] });
    autocomplete.addListener("place_changed", fillInAddress);
  };

  const fillInAddress = () => {
    const place = autocomplete.getPlace();

    for (let component in componentForm1) {
      document.getElementById(component).value = "";
    }

    for (let i = 0; i < place.address_components.length; i++) {
      const addressType = place.address_components[i].types[0];
      if (componentForm1[addressType]) {
        const val = place.address_components[i][componentForm1[addressType]];
        document.getElementById(addressType).value = val;
      }
    }
  };

  const getSlots = async (date, PcatId) => {
    console.log(date, PcatId);
    try {
      setSlotLoading(true);
      let url = `AppoinmentSlot/SlotByParentId?date=${date}&PcatgroupId=${PcatId}`;
      const response = await privateRequest.get(url);
      setSlotData(response?.data?.data);
      setSlotsPreview(response?.data?.data[0]?.slot);
      console.log("response?.data[0]?.slot", response?.data?.data[0]?.slot);
      setSlotLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const getServices = async (selectedGroupId) => {
    try {
      let url = `Service/servicepackagebyPcgroup/` + selectedGroupId;
      const response = await privateRequest.get(url);

      setServices(response?.data?.data);
      console.log("Services loaded:", response?.data?.data?.length, "services for group:", selectedGroupId);
      console.log("Services data:", response?.data?.data);
    } catch (error) {
      console.error("Error loading services:", error);
      setServices([]); // Set empty array on error
    }
  };
  console.log("paramsData", paramsData);

  useEffect(() => {
    if (paramsData) {
      getSlots(paramsData?.slotDate, paramsData?.cart[0]?.PCGroup?._id);
    }
  }, [paramsData]);

  // useEffect(() => {
  //   if (slotData) {
  //     const filteredData = slotData?.filter(
  //       (item) => item?.slotDate === paramsData?.slotDate
  //     );
  //     setSlotsPreview(filteredData);
  //   }
  // }, [slotData]);

  const handleGroupChange = (selectedOption) => {
    const selectedGroupId = selectedOption.value;
    const selectedGroupLabel = selectedOption.label;

    setSelectedGroup({
      label: selectedGroupLabel,
      value: selectedGroupId,
    });
    // getOtherCharges(selectedGroupId);
  };
  useEffect(() => {
    if (selectedGroup) {
      getServices(selectedGroup?.value);
    }
  }, [selectedGroup]);

  const updateServiceId = (id, newName) => {
    console.log("data in update", id, newName);

    // Check if the service is actually being changed
    const currentItem = itemssss[id];
    if (currentItem?.value?.value === newName) {
      console.log("Service not changed, skipping update");
      return;
    }

    const updatedItems = itemssss?.map((item, index) => {
      if (index === id) {
        const Service = services?.find((option) => {
          const variantId = option?.ServiceVarients?.[0]?._id;
          const serviceId = option?._id;
          return variantId === newName || serviceId === newName;
        });

        console.log("Service", Service);
        if (!Service) {
          return item;
        }

        let serviceName = "Unknown Service";

        if (Service.ServiceVarients?.[0]?.ServiceType) {
          const serviceType = Service?.ServiceVarients[0].ServiceType;
          serviceName =
            serviceType.Name !== "NA"
              ? `${Service?.ServiceName} - ${serviceType?.Name}`
              : Service?.ChildCatIDs
              ? `${Service?.ServiceName} - ${Service?.ChildCatIDs.CCName}`
              : "Unknown Service";
        } else {
          console.log("servicename", Service);
        }

        const Amount = Service?.packageTitle
          ? parseInt(Service?.payble) * parseInt(item.Quantity)
          : parseInt(Service?.ServiceVarients?.[0]?.VarientDiscription[0]?.salePrice) * parseInt(item.Quantity);
        
        let packageNames = [];
        const time = Service?.serviceId?.reduce((sum, serviceObj) => {
          const serviceTime = parseInt(
            serviceObj?.service?.ServiceVarients[0]?.VarientDiscription[0]
              ?.ServiceTime,
            10
          );

          const serviceTypee =
            serviceObj?.service?.ServiceVarients[0]?.ServiceType;

          let serviceNamee =
            serviceTypee?.Name !== "NA"
              ? `${serviceObj?.service.ServiceName} - ${serviceTypee?.Name}`
              : serviceObj?.service.ChildCatIDs
              ? `${serviceObj?.service.ServiceName} - ${serviceObj?.service.ChildCatIDs.CCName}`
              : "Unknown Service";

          packageNames.push(serviceNamee);

          return sum + (isNaN(serviceTime) ? 0 : serviceTime);
        }, 0);

        return {
          ...item,
          id: Service?.ServiceVarients?.[0]?._id || Service._id,
          value: {
            label: Service?.packageTitle || serviceName,
            value: newName,
          },
          packagetotalPrice:
            parseInt(Service?.payble) ||
            parseInt(
              Service?.ServiceVarients?.[0]?.VarientDiscription[0]?.salePrice
            ),
          packageRegulerPrice:
            parseInt(Service?.RPrice) ||
            parseInt(
              Service?.ServiceVarients?.[0]?.VarientDiscription[0]?.regularPrice
            ),
          packageTitle: Service.packageTitle || serviceName,
          packageTotalTime:
            time ||
            Service?.ServiceVarients?.[0]?.VarientDiscription[0]?.ServiceTime,
          type: Service.ServiceName ? "Service" : "Normal Package",
          PCGroup: selectedGroup?.value,
          Amount: Amount,
          PCatId: Service.packageTitle ? Service?.PcatId : Service?.PCatId?._id,
          packageName: packageNames || [],
        };
      }
      return item;
    });

    setItemssss(updatedItems);
  };

  const updateQuantity = (id, newQuantity) => {
    const updatedItems = itemssss.map((item, index) => {
      if (index === id) {
        const Amount =
          parseFloat(item.packagetotalPrice) * parseInt(newQuantity);

        return { ...item, Quantity: newQuantity, Amount: Amount };
      }
      return item;
    });

    setItemssss(updatedItems);
  };

  const updateEditPackageQuantity = (index, newQuantity) => {
    const updatedPackages = EditPackages.map((item, i) => {
      if (i === index) {
        const Amount =
          parseFloat(item.packagetotalPrice) * parseInt(newQuantity);

        return { ...item, Quantity: newQuantity, Amount: Amount };
      }
      return item;
    });

    setEditPackages(updatedPackages);
  };

  const fillTargetArray = () => {
    if (!paramsData || !paramsData.cart || !services || services.length === 0) return;
    
    console.log("fillTargetArray called - preserving existing data");
    
    // Update existing items while preserving their original structure
    setItemssss((prevSelectedServices) => {
      return prevSelectedServices.map((prevItem, index) => {
        // Find corresponding service only to get additional metadata if needed
        const Service = services?.find((option) => {
          const variantId = option?.ServiceVarients?.[0]?._id;
          const serviceId = option?._id;
          
          return variantId === prevItem.id || serviceId === prevItem.id;
        });

        // Preserve all original item data, only add missing fields if necessary
        return {
          ...prevItem,
          // Keep original value structure intact
          value: prevItem.value || {
            label: prevItem.packageTitle || "Unknown Service",
            value: prevItem.id,
          },
          // Keep all original pricing and metadata
          packagetotalPrice: prevItem.packagetotalPrice,
          packageRegulerPrice: prevItem.packageRegulerPrice,
          packageTitle: prevItem.packageTitle,
          packageTotalTime: prevItem.packageTotalTime,
          type: prevItem.type,
          Amount: prevItem.Amount,
          PCatId: prevItem.PCatId,
          PCGroup: selectedGroup?.value || prevItem.PCGroup,
        };
      });
    });
  };

  // Load cart items when paramsData is available
  useEffect(() => {
    if (!paramsData || !paramsData.cart) {
      console.log("No paramsData or cart available");
      return;
    }

    // Reset hasEffectRun when new paramsData is loaded
    hasEffectRun.current = false;

    console.log("Loading cart items. Total cart items:", paramsData.cart.length);
    
    const nonEditableItems = paramsData.cart.filter(
      (item) => item?.type !== "Editable"
    );
    
    const editableItems = paramsData.cart.filter(
      (item) => item?.type === "Editable"
    );

    console.log("Non-editable items:", nonEditableItems.length);
    console.log("Editable items:", editableItems.length);
    console.log("Non-editable items data:", nonEditableItems);

    // Create items with proper structure for Select components - preserve original data
    const processedItems = nonEditableItems.map((item, index) => ({
      ...item,
      _id: index,
      // Preserve original value structure from API
      value: {
        label: item.packageTitle || "Unknown Service",
        value: item.id,
      },
      // Use original values from API
      packagetotalPrice: item.packagetotalPrice || 0,
      packageRegulerPrice: item.packageRegulerPrice || 0,
      packageTotalTime: item.packageTotalTime || 0,
      Amount: item.Amount || 0,
      Quantity: item.Quantity || 1,
    }));

    console.log("Processed items for itemssss:", processedItems);
    setItemssss(processedItems);
  }, [paramsData]);

  // Fill additional service details when services are loaded - only once
  useEffect(() => {
    if (services && services.length > 0 && itemssss.length > 0 && !hasEffectRun.current) {
      fillTargetArray();
      hasEffectRun.current = true;
    }
  }, [services, itemssss]);

  let totalRegulerPrice = 0;
  let totalSalePrice = 0;
  let totalTime = 0;
  itemssss?.forEach((item) => {
    totalRegulerPrice +=
      parseFloat(item.packageRegulerPrice) * parseInt(item.Quantity);
    totalSalePrice +=
      parseFloat(item.packagetotalPrice) * parseInt(item.Quantity);
    totalTime += parseFloat(item?.packageTotalTime) * parseInt(item.Quantity);
  });

  let totalDiscount = totalRegulerPrice - totalSalePrice;

  let totalSumofOtherCharges = otherCharges
    ? otherCharges?.reduce(
        (accumulator, currentCharge) =>
          accumulator + parseFloat(currentCharge.price),
        0
      )
    : 0;
  let discounttt = parseInt(couponValue);

  let d = concession > 0 ? parseFloat(concession) : 0;

  useEffect(() => {
    if (paramsData) {
      let f = paramsData?.cart.filter((item) => item.type == "Editable");
      setEditPackages(f);
    }
  }, [paramsData]);

  // let EditPackages = paramsData?.cart.filter((item) => item.type == "Editable");
  EditPackages?.forEach((item) => {
    totalRegulerPrice +=
      parseFloat(item.packageRegulerPrice) * parseInt(item.Quantity);
    totalSalePrice +=
      parseFloat(item.packagetotalPrice) * parseInt(item.Quantity);
    totalTime += parseFloat(item?.packageTotalTime) * parseInt(item.Quantity);
  });

let totalAmount =
  (Number(surg) || 0) +
  (Number(totalSalePrice) || 0) +
  (Number(totalSumofOtherCharges) || 0) -
  (Number(d) || 0) -
  (Number(discounttt) || 0) +
  (Number(tip) || 0) -
  (Number(paramsData?.WalletDataChekAmaunt) || 0);

  function removeIdFromItems(items) {
    return itemssss.map((item) => {
      const { _id, ...rest } = item;
      return rest;
    });
  }
  const itemsWithoutIdd = removeIdFromItems(itemssss);

  const removeBlankItems = (items) => {
    return items.filter((item) => item.id && item.packageTitle);
  };

  const itemsWithoutId = removeBlankItems(itemsWithoutIdd);

  useEffect(() => {
    if (selectedAddress) {
      setFullAdress(selectedAddress?.FullAddress);
      setApartment(selectedAddress?.buildingName);
      setHouse(selectedAddress?.houseOrFlatNo);
      setLandmark(selectedAddress?.landmark);
      setSelectedOption(selectedAddress?.SaveAs);
    }
  }, [selectedAddress]);

  useEffect(() => {
    if (paramsData && slotData) {
      let data = slotData;
      let id = paramsData?.slotTime;
      setSurg(paramsData.surgeCharges);

      for (let entry of data) {
        for (let slot of entry.slot) {
          if (slot.slotTime === id) {
            setselectedSlot(slot.slotTime);
            return;
          }
        }
      }
    }
  }, [paramsData, slotData]);

  let abcPackages =
    EditPackages &&
    [...EditPackages, ...itemsWithoutId].map((packagee) => {
      if (typeof packagee.PCGroup === "object" && packagee.PCGroup._id) {
        return {
          ...packagee,
          PCGroup: packagee.PCGroup._id,
        };
      }
      return packagee;
    });

  console.log("abcPackages", abcPackages);

  const requestBody = {
    slotDate: selectedDate,
    slotTime: selectedSlot,
    name: name,
    clientAddressId: selectedAddress?._id,
    TServiceTiming: totalTime,
    jobsSource: source,
    RPrice: totalRegulerPrice,
    email: email,
    mobileNo: mobile,
    SPrice: totalSalePrice,
    concession: concession,
    tip: tip,
    surgeCharges: surg,
    cancelCharges: "0",
    payableCharges: totalAmount,
    cart: abcPackages || itemsWithoutId,
    payment_Mode: "",
    Status: "pending",
    houseOrFlatNo: house || selectedAddress?.houseOrFlatNo,
    buildingName: apartment || selectedAddress?.buildingName,
    landmark: landmark || selectedAddress?.landmark,
    FullAddress: fullAdress || selectedAddress?.FullAddress,
    location: {
      longitude: longitude || selectedAddress?.location?.longitude,
      latitude: latitude || selectedAddress?.location?.latitude,
    },
    SaveAs: selectedOption,
  };

  const extractCommonPcatIds = (dataArray) => {
    const commonPcatIds = new Set();
    dataArray.forEach((item) => {
      if (item?.PCatId && item?.PCatId !== undefined) {
        commonPcatIds.add(item?.PCatId);
      }
    });
    return Array.from(commonPcatIds);
  };
  console.log("itemsWithoutId", itemsWithoutId);

  const commonPcatIds = extractCommonPcatIds(itemsWithoutId);

  const getHighestValueCharges = (data) => {
    const chargesMap = {};

    data.forEach((charge) => {
      const { ChargesName, ChargesValue } = charge;
      if (
        !chargesMap[ChargesName] ||
        chargesMap[ChargesName].ChargesValue < ChargesValue
      ) {
        chargesMap[ChargesName] = charge;
      }
    });

    return Object.values(chargesMap);
  };

  const getOtherCharges = async () => {
    try {
      let url = `OtherCharges/OtherChargeByPId`;
      const response = await privateRequest.post(url, {
        Pcat: commonPcatIds,
      });
      let a = getHighestValueCharges(response?.data?.Data);

      let chargesInfo = a?.map((charge) => ({
        charge: charge.ChargesName,
        price: charge.ChargesValue,
      }));

      setOtherCharges(chargesInfo);
      setItemRemoved(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedAddress) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please select or add a address",
      });
      return;
    }

    console.log("Submitting job update with items:", itemssss);
    console.log("Request body cart:", abcPackages);

    try {
      setLoading(true);
      const response = await privateRequest.post(
        `jobs/UpdateJob/${id}`,
        requestBody
      );
      navigate("/todaysjob");
      setLoading(false);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Order Updated successfully!",
      });
    } catch (error) {
      if (error.response?.data) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          // text: "Error creating Order",
          text: error.response?.data?.message,
        });
        setLoading(false);
      }
      console.error("Error updating Order:", error);
    }
  };

  const deleteChild = async (obj, e) => {
    e.preventDefault();
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `Address/DeleteAddressByMobile`,
          {
            data: obj,
          }
        );

        if (response) {
          getUsersData();
        }

        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  const handleAddress = (e) => {
    geocodeByAddress(fullAdress)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        console.log("Successfully got latitude and longitude", { lat, lng });
        setLatitude(lat);
        setLongitude(lng);
      })
      .catch((error) => {
        console.error("Error geocoding address:", error);
        // Handle errors here, such as displaying an error message to the user
      });
  };
  const handleOnchage = (place) => {
    setFullAdress(place?.description);
  };

  useEffect(() => {
    if (fullAdress) {
      handleAddress();
    }
  }, [fullAdress]);

  const validateAddress = () => {
    if (!fullAdress) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please enter a valid location",
      });
      return false;
    }
    if (!house) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please enter House or Flat Number",
      });
      return false;
    }

    if (!apartment) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please enter Building Name",
      });
      return false;
    }

    if (!mobile) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please enter Mobile Number",
      });
      return false;
    }

    if (!selectedOption) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please select an option for Save As",
      });
      return false;
    }

    return true;
  };
  const EditUserAddress = async () => {
    try {
      if (!validateAddress()) {
        return;
      }

      let adres = {
        houseOrFlatNo: house,
        addressId: selectedItem?._id,
        buildingName: apartment,
        FullAddress: fullAdress,
        landmark: landmark,
        mobileNo: mobile,
        location: {
          longitude: longitude,
          latitude: latitude,
        },
        SaveAs: selectedOption,
      };

      let adress = {
        houseOrFlatNo: house,
        buildingName: apartment,
        FullAddress: fullAdress,
        landmark: landmark,
        mobileNo: mobile,
        location: {
          longitude: longitude,
          latitude: latitude,
        },
        SaveAs: selectedOption,
      };

      if (addresses.length > 0) {
        if (selectedItem) {
          // adres.addressId = selectedItem.id;
          let response = await privateRequest.put(
            "Address/UpdateAddressByMobile",

            adres
          );

          if (response) {
            getUsersData();
            setCreateValid(true);
          }
          Swal.fire("Updated!", "Your address has been updated.", "success");
        } else {
          let response = await privateRequest.post(
            "Address/CreateAddressWithMobile",
            adress
          );

          if (response) {
            setCreateValid(true);
            getUsersData();
          }
          Swal.fire("Saved!", "Your address has been saved.", "success");
        }
      } else if (addresses.length < 1 && usersData[0]?.mobileNo == mobile) {
        let response = await privateRequest.post(
          "Address/CreateAddressWithMobile",
          adress
        );

        if (response) {
          setCreateValid(true);
          getUsersData();
        }
        Swal.fire("Saved!", "Your address has been saved.", "success");
      } else {
        localStorage.setItem("adres", JSON.stringify(adres));
        Swal.fire(
          "Saved!",
          "Your address has been saved to local storage.",
          "success"
        );
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error!", "Failed to save address.", "error");
    }
  };
  const updatedData = slotsPreview?.map((item) => {
    const updatedSlotTime = item.slotTime.replace(/(AM|PM)/, "");
    return { ...item, slotTime: updatedSlotTime };
  });

  // useEffect(() => {
  //   if (PCgroup) {
  //     let a = new Date().toISOString().split("T")[0];
  //     getSlots(a, PCgroup[0]?._id);
  //   }
  // }, [PCgroup]);

  return (
    <div className="app has-fullwidth">
      <main className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Edit Job</span>
                    </p>
                    <Link
                      to={"/todaysjob"}
                      className="ml-auto btn btn-primary btn-sm"
                    >
                      All Jobs
                    </Link>
                  </div>
                </header>

                <div className="page-section">
                  <form id="new_job" className="needs-validation" novalidate="">
                    <div className="row mb-3">
                      <div className="col-lg-6">
                        <div className="card" style={{ height: "100%" }}>
                          <div className="card-header">
                            <h4 className="card-title mb-0">
                              Customer Details
                            </h4>
                          </div>
                          <div className="card-body row pb-0 mb-0">
                            <div className="form-group col-lg-6">
                              <label>Mobile No</label>
                              <div className="has-spinner">
                                <div
                                  className={
                                    loading == false
                                      ? "spinner-border spinner-border-sm text-primary"
                                      : "spinner-border spinner-border-sm text-primary show"
                                  }
                                  role="status"
                                >
                                  <span className="sr-only">Loading...</span>
                                </div>

                                <input
                                  value={mobile}
                                  onChange={(e) => {
                                    setMobile(e.target.value);
                                  }}
                                  type="text"
                                  className="form-control"
                                  placeholder="Mobile No"
                                  id="cx_mobile"
                                  name="cx_mobile"
                                  required=""
                                  maxLength={10}
                                />
                              </div>
                            </div>
                            <div className="form-group col-lg-6">
                              <label>Name</label>
                              <input
                                value={name}
                                onChange={(e) => {
                                  setName(e.target.value);
                                }}
                                type="text"
                                className="form-control"
                                placeholder="Name"
                                id="cx_name"
                                name="cx_name"
                                required=""
                              />
                            </div>
                            <div className="form-group col-lg-6">
                              <label>Email</label>
                              <input
                                value={email}
                                onChange={(e) => {
                                  setEmail(e.target.value);
                                }}
                                type="email"
                                className="form-control"
                                placeholder="Email ID"
                                id="cx_email"
                                name="cx_email"
                                required=""
                              />
                            </div>
                            <div className="form-group col-lg-6">
                              <label>Parent Category Group</label>
                              <Select
                                isClearable
                                options={PCgroup?.map((group) => ({
                                  value: group._id,
                                  label: group.PCGName,
                                }))}
                                onChange={handleGroupChange}
                                value={selectedGroup}
                                isMulti={false}
                              />
                            </div>

                            <div className="form-group col-lg-6">
                              <label>Select Source</label>
                              <select
                                className="form-control"
                                name="job_src"
                                id="job_src"
                                value={source}
                                onChange={(e) => {
                                  setSource(e.target.value);
                                }}
                              >
                                <option value={"Whats app"}>Whats app</option>
                                <option value={"Facebook"}>Facebook</option>
                                <option value={"Website"}>Website</option>
                                <option value={"Android App"}>
                                  Android App
                                </option>
                                <option value={"Reffer"}>Reffer</option>
                                <option value={"GMB"}>GMB</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="card" style={{ height: "100%" }}>
                          <div className="card-header d-flex justify-content-between align-items-center">
                            <h4 className="card-title mb-0">Address Details</h4>
                            <a
                              onClick={() => {
                                setApartment("");
                                setLandmark("");
                                setHouse("");
                                setFullAdress("");
                              }}
                              href="javascript:void(0)"
                              data-toggle="modal"
                              data-target="#exampleModalCenter"
                            >
                              <i className="fa fa-plus mr-2"></i>Add Address
                            </a>
                          </div>
                          <div
                            className="card-body py-2"
                            style={{ height: "200px", overflow: "auto" }}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                {addresses.length > 0 &&
                                  addresses.map((item, index) => {
                                    return (
                                      <div className="form-group" key={index}>
                                        <div className="custom-control custom-radio d-flex justify-content-between align-items-center">
                                          <div>
                                            <input
                                              type="radio"
                                              className="custom-control-input"
                                              name="rdGroup2"
                                              id={`address-${index}`}
                                              onChange={() =>
                                                setSelectedAddress(item)
                                              }
                                              checked={
                                                selectedAddress?._id ===
                                                item?._id
                                              }
                                            />
                                            <label
                                              className="custom-control-label"
                                              htmlFor={`address-${index}`}
                                            >
                                              <strong className="text-capitalize">
                                                {item?.SaveAs}
                                              </strong>
                                              <p className="mb-0">
                                                {item?.houseOrFlatNo},{" "}
                                                {item?.buildingName},{" "}
                                                {item?.landmark
                                                  ? item?.landmark
                                                  : ""}
                                              </p>
                                              <p>{item?.FullAddress}</p>
                                            </label>
                                          </div>

                                          <div className="btn-group">
                                            <button
                                              type="button"
                                              href="javascript:void(0)"
                                              data-toggle="modal"
                                              data-target="#exampleModalCenter"
                                              className="btn btn-primary btn-sm rounded-0"
                                              onClick={() => {
                                                setApartment(
                                                  item?.buildingName
                                                );
                                                setFullAdress(
                                                  item?.FullAddress
                                                );
                                                setselectedItem(item);
                                                setHouse(item?.houseOrFlatNo);
                                                setLandmark(
                                                  item?.landmark
                                                    ? item?.landmark
                                                    : " "
                                                );
                                              }}
                                            >
                                              <i className="fa fa-edit"></i>
                                            </button>
                                            <button
                                              onClick={(e) => {
                                                let obj = {
                                                  mobileNo: mobile,
                                                  addressId: item?._id,
                                                };
                                                deleteChild(obj, e);
                                              }}
                                              type="button"
                                              className="btn btn-danger btn-sm rounded-0"
                                            >
                                              <i className="fa fa-trash"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <h4 className="card-title mb-0">Slot Details</h4>
                      </div>
                      {/* <div className="card-body">
                        <div className="row">
                          <div className="col-lg-12 slotDates">
                            {slotDates?.map((item, index) => {
                              return (
                                <div className="visual-picker visual-picker-sm has-peek mr-2 mb-3">
                                  <input
                                    type="radio"
                                    id={index + "date"}
                                    value={item}
                                    name="slot_date"
                                    className="slot_input"
                                    checked={
                                      slotsPreview &&
                                      slotsPreview[0]?.slotDate == item
                                    }
                                    onChange={(e) => {
                                      const filteredData = slotData.filter(
                                        (slot) =>
                                          slot.slotDate === e.target.value
                                      );

                                      setSlotsPreview(filteredData);
                                      setselectedSlot(null);
                                    }}
                                  />
                                  <label
                                    className="visual-picker-figure"
                                    htmlFor={index + "date"}
                                  >
                                    <small className="visual-picker-content slotDate">
                                      {moment(item).format("dddd").slice(0, 3)}
                                    </small>

                                    <small className="visual-picker-content slotDay">
                                      {moment(item).format("D")}
                                    </small>
                                  </label>
                                  <small
                                    style={{
                                      position: "absolute",
                                      top: "21px",
                                      background: "yellow",
                                      padding: "0px 13px",
                                      right: "25%",
                                      borderRadius: "22px",
                                    }}
                                  ></small>
                                </div>
                              );
                            })}
                          </div>
                          <div className="col-lg-12 mt-4">
                            {slotsPreview &&
                              slotsPreview[0]?.slot?.map((item, index) => {
                                return (
                                  <div
                                    key={index}
                                    className="visual-picker visual-picker-sm has-peek mr-2 mb-3"
                                  >
                                    <input
                                      type="radio"
                                      id={index + "time"}
                                      className="slot_input"
                                      checked={selectedSlot === item.slotTime}
                                      required=""
                                      value={item.slotTime}
                                      name="time_slot[]"
                                      onChange={(e) => {
                                        setselectedSlot(e.target.value);
                                        setSurg(parseFloat(item?.surgCharges));
                                      }}
                                    />
                                    <label
                                      className="visual-picker-figure"
                                      htmlFor={index + "time"}
                                    >
                                      <small className="visual-picker-content slot_span">
                                        {item.slotTime}
                                      </small>
                                      {item.surgCharges !== 0 && (
                                        <small className="badge badge-warning surgeCharge_span">
                                          {item.surgCharges}
                                        </small>
                                      )}
                                    </label>
                                    <small
                                      style={{
                                        position: "absolute",
                                        top: "21px",
                                        background: "yellow",
                                        padding: "0px 13px",
                                        right: "25%",
                                        borderRadius: "22px",
                                      }}
                                    ></small>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div> */}
                      <div className="card-body">
                        <div className="row">
                          <div className="col-12 slotDates">
                            <input
                              type="date"
                              id="dateFilter"
                              className="form-control"
                              value={selectedDate}
                              onChange={(e) => {
                                setSelectedDate(e.target.value);

                                if (selectedGroup?.value) {
                                  getSlots(
                                    e.target.value,
                                    selectedGroup?.value
                                  );
                                } else {
                                  Swal.fire({
                                    icon: "error",
                                    title: "Error!",
                                    // text: "Error creating Order",
                                    text: "Please select parent category group",
                                  });
                                }
                              }}
                            />
                          </div>
                          <div className="col-lg-12 mt-4 ">
                            {slotLoading ? (
                              <div className="text-center">
                                <div
                                  class="spinner-border text-primary loader p-3 my-4 "
                                  role="status"
                                >
                                  <span class="sr-only">Loading...</span>
                                </div>
                              </div>
                            ) : (
                              <>
                                {slotsPreview &&
                                  updatedData?.map((item, index) => {
                                    let styles = {
                                      backgroundColor: "gray",
                                      color: "#fff",
                                    };
                                    return (
                                      <div
                                        key={index}
                                        className="visual-picker visual-picker-sm has-peek mr-2 mb-3"
                                      >
                                        <input
                                          type="radio"
                                          id={index + "time"}
                                          className="slot_input"
                                          checked={
                                            selectedSlot === item.slotTime
                                          }
                                          required=""
                                          value={item.slotTime}
                                          name="time_slot[]"
                                          onChange={(e) => {
                                            setselectedSlot(e.target.value);
                                            setSurg(
                                              parseFloat(item?.surgCharges)
                                            );
                                          }}
                                        />
                                        <label
                                          className="visual-picker-figure"
                                          htmlFor={index + "time"}
                                        >
                                          <small
                                            className="visual-picker-content slot_span"
                                            style={
                                              item?.statusButton == false &&
                                              selectedSlot != item.slotTime
                                                ? styles
                                                : null
                                            }
                                          >
                                            {item.slotTime}
                                          </small>
                                          {item.surgCharges !== 0 && (
                                            <small className="badge badge-warning surgeCharge_span">
                                              {item.surgCharges}
                                            </small>
                                          )}
                                        </label>
                                        <small
                                          style={{
                                            position: "absolute",
                                            top: "21px",
                                            background: "yellow",
                                            padding: "0px 13px",
                                            right: "25%",
                                            borderRadius: "22px",
                                          }}
                                        ></small>
                                      </div>
                                    );
                                  })}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-body border-top border-bottom">
                        <h4 className="card-title mb-0">Cart Details</h4>
                      </div>
                      <div className="card-body pb-0 mb-0">
                        <div className="row">
                          <div className="col-lg-12">
                            <table
                              id="itemTable"
                              className="table table-bordered"
                            >
                              <thead>
                                <tr>
                                  <th>Service/Package</th>
                                  <th
                                    style={{ width: "10%" }}
                                    className="text-right"
                                  >
                                    Quantity
                                  </th>

                                  <th
                                    style={{ width: "15%" }}
                                    className="text-right"
                                  >
                                    Rate
                                  </th>

                                  <th
                                    style={{ width: "15%" }}
                                    className="text-right"
                                  >
                                    Amount
                                  </th>
                                  <th style={{ width: "5%" }}></th>
                                </tr>
                              </thead>
                              <tbody>
                                {EditPackages?.length > 0 &&
                                  EditPackages?.map((item, index) => {
                                    return (
                                      <tr key={`edit-${index}-${item?.id}`}>
                                        <td>
                                          {/* <Select
                                            isClearable
                                            key={index}
                                            // label={item?.value}
                                            options={
                                              services
                                                ? services.map((group) => {
                                                    let serviceName =
                                                      "Unknown Service";

                                                    if (
                                                      group.ServiceVarients &&
                                                      group
                                                        .ServiceVarients[0] &&
                                                      group.ServiceVarients[0]
                                                        .ServiceType
                                                    ) {
                                                      const serviceType =
                                                        group.ServiceVarients[0]
                                                          .ServiceType;
                                                      serviceName =
                                                        serviceType.Name !==
                                                        "NA"
                                                          ? `${group.ServiceName} - ${serviceType.Name}`
                                                          : group.ChildCatIDs
                                                          ? `${group.ServiceName} - ${group.ChildCatIDs.CCName}`
                                                          : "Unknown Service";
                                                    }
                                                    let val =
                                                      (group.ServiceVarients &&
                                                        group
                                                          .ServiceVarients[0] &&
                                                        group.ServiceVarients[0]
                                                          ?._id) ||
                                                      group?._id;
                                                    return {
                                                      // value: group._id,
                                                      value: val,
                                                      label:
                                                        group.packageTitle ||
                                                        serviceName,
                                                    };
                                                  })
                                                : []
                                            }
                                            onChange={(selectedOption) => {
                                              const selectedValue =
                                                selectedOption
                                                  ? selectedOption.value
                                                  : null;
                                              updateServiceId(
                                                index,
                                                selectedValue
                                              );

                                              getOtherCharges();
                                              setItemRemoved(true);
                                            }}
                                            isMulti={false}
                                            value={item?.value}
                                            // value={item?.id + index}
                                          /> */}
                                          {item?.packageTitle}
                                        </td>
                                        <td>
                                          <input
                                            min="0"
                                            type="number"
                                            className="form-control form-control-sm border-0 shadow-none text-right serviceQty"
                                            value={item?.Quantity}
                                            name={`service_item[${item.id}][s_qty]`}
                                            onChange={(e) => {
                                              updateEditPackageQuantity(
                                                index,
                                                parseInt(e.target.value)
                                              );
                                            }}
                                          />
                                        </td>

                                        <td>
                                          <input
                                            type="number"
                                            readOnly
                                            className="form-control form-control-sm border-0 shadow-none text-right txt_rate"
                                            value={item?.packagetotalPrice}
                                            onChange={(e) => {}}
                                            name={`service_item[${item.id}][s_rate]`}
                                          />
                                        </td>

                                        <td align="right">
                                          <input
                                            type="number"
                                            readOnly
                                            value={item?.Amount}
                                            className="form-control form-control-sm border-0 shadow-none text-right item_qty_amount_total amt_will_add"
                                          />
                                        </td>
                                        <td className="text-center">
                                          <button
                                            onClick={() => {
                                              // removeItem(item?._id);
                                              removePackage(item?.id);
                                            }}
                                            type="button"
                                            className="btn btnDelete"
                                          >
                                            <i className="fa fa-times-circle text-danger "></i>
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                {itemssss?.map((item, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>
                                        {services && services.length > 0 ? (
                                          <Select
                                            isClearable
                                            key={`${index}-${item?.id}`}
                                            options={
                                              services.map((group) => {
                                                let serviceName =
                                                  "Unknown Service";

                                                if (
                                                  group.ServiceVarients &&
                                                  group.ServiceVarients[0] &&
                                                  group.ServiceVarients[0]
                                                    .ServiceType
                                                ) {
                                                  const serviceType =
                                                    group.ServiceVarients[0]
                                                      .ServiceType;
                                                  serviceName =
                                                    serviceType.Name !== "NA"
                                                      ? `${group.ServiceName} - ${serviceType.Name}`
                                                      : group.ChildCatIDs
                                                      ? `${group.ServiceName} - ${group.ChildCatIDs.CCName}`
                                                      : "Unknown Service";
                                                }
                                                let val =
                                                  (group.ServiceVarients &&
                                                    group
                                                      .ServiceVarients[0] &&
                                                    group.ServiceVarients[0]
                                                      ?._id) ||
                                                  group?._id;
                                                return {
                                                  value: val,
                                                  label:
                                                    group.packageTitle ||
                                                    serviceName,
                                                };
                                              })
                                            }
                                            onChange={(selectedOption) => {
                                              const selectedValue = selectedOption
                                                ? selectedOption.value
                                                : null;
                                              
                                              // Only update if value is actually different
                                              if (selectedValue && selectedValue !== item?.value?.value) {
                                                updateServiceId(
                                                  index,
                                                  selectedValue
                                                );
                                                getOtherCharges();
                                                setItemRemoved(true);
                                              }
                                            }}
                                            isMulti={false}
                                            value={item?.value}
                                            placeholder="Select Service/Package"
                                          />
                                        ) : (
                                          <div className="p-2 bg-light border rounded">
                                            <strong>{item?.packageTitle || "Loading..."}</strong>
                                            {!services && <small className="text-muted d-block">Loading services...</small>}
                                            {services && services.length === 0 && <small className="text-danger d-block">No services available</small>}
                                          </div>
                                        )}
                                      </td>
                                      <td>
                                        <input
                                          min="0"
                                          type="number"
                                          className="form-control form-control-sm border-0 shadow-none text-right serviceQty"
                                          value={item?.Quantity}
                                          name={`service_item[${item.id}][s_qty]`}
                                          onChange={(e) => {
                                            updateQuantity(
                                              index,
                                              parseInt(e.target.value)
                                            );
                                          }}
                                        />
                                      </td>

                                      <td>
                                        <input
                                          type="number"
                                          readOnly
                                          className="form-control form-control-sm border-0 shadow-none text-right txt_rate"
                                          value={item?.packagetotalPrice}
                                          onChange={(e) => {}}
                                          name={`service_item[${item.id}][s_rate]`}
                                        />
                                      </td>

                                      <td align="right">
                                        <input
                                          type="number"
                                          readOnly
                                          value={item?.Amount}
                                          className="form-control form-control-sm border-0 shadow-none text-right item_qty_amount_total amt_will_add"
                                        />
                                      </td>
                                      <td className="text-center">
                                        <button
                                          onClick={() => {
                                            // removeItem(item?._id);
                                            removeItem(item?.value.value);
                                          }}
                                          type="button"
                                          className="btn btnDelete"
                                        >
                                          <i className="fa fa-times-circle text-danger "></i>
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                          <div className="col-lg-6">
                            <div className="btn-group">
                              <button
                                onClick={() => {
                                  addRow();
                                }}
                                type="button"
                                className="btn btn-primary insert_service_Line btn-sm"
                              >
                                <i className="fa fa-plus-circle text-white"></i>{" "}
                                Add Another Item
                              </button>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <table className="table invoiceTable">
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Regular / Sale Price</strong>
                                  </td>
                                  <td className="text-right d-flex">
                                    <span className="mr-2">₹</span>
                                    <input
                                      type="text"
                                      readOnly
                                      className="form-control text-right mr-2"
                                      id="regular_price_spn"
                                      value={totalRegulerPrice}
                                      name="regular_price_spn"
                                    />
                                    <input
                                      type="text"
                                      readOnly
                                      id="sale_price_spn"
                                      className="form-control text-right"
                                      value={totalSalePrice}
                                      name="sale_price_spn"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Discount</strong>
                                  </td>
                                  <td className="text-right d-flex">
                                    <span className="mr-2">₹</span>
                                    <label
                                      className="form-control text-right"
                                      id="total_discount"
                                    >
                                      {totalDiscount}
                                    </label>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Tip</strong>
                                  </td>
                                  <td className="text-right d-flex">
                                    <span className="mr-2">₹</span>
                                    <input
                                      min="0"
                                      name="slug_amt"
                                      type="number"
                                      id="slug_amt"
                                      value={tip}
                                      onChange={(e) => {
                                        let value = parseInt(
                                          e.target.value != 0
                                            ? e.target.value
                                            : 0
                                        );
                                        setTip(value);
                                      }}
                                      className="form-control text-right amt_will_add"
                                    />
                                    {/* <label
                                      className="form-control text-right"
                                      id="total_discount"
                                    >
                                      {paramsData?.tip}
                                    </label> */}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong className="d-block">
                                      Coupon Discount
                                    </strong>

                                    <small
                                      className="badge badge-danger"
                                      style={{ backgroundColor: "red" }}
                                    >
                                      {paramsData?.couponCode}
                                    </small>
                                  </td>
                                  <td className="text-right d-flex">
                                    <span className="mr-2">₹</span>
                                    <input
                                      className="form-control text-right"
                                      id="total_discount"
                                      type="number"
                                      value={couponValue}
                                      onChange={(e) => {
                                        setcouponValue(e.target.value);
                                      }}
                                    ></input>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong className="d-block">
                                    Wallet Amaunt
                                    </strong>

                                   
                                  </td>
                                  <td className="text-right d-flex">
                                    <span className="mr-2">₹</span>
                                    <input
                                      className="form-control text-right"
                                      id="wallet_amount"
                                      type="text"
                                      value={paramsData?.WalletDataChekAmaunt || 0}
                                      readOnly
                                      
                                    ></input>
                                  </td>
                                </tr>

                                {/* <tr>
                                  <td>
                                    <strong>Convenience</strong>
                                  </td>
                                  <td className="text-right d-flex">
                                    <span className="mr-2">₹</span>
                                    <input
                                      name="convenience"
                                      onBlur="calculation()"
                                      type="tel"
                                      id="convenience"
                                      value="0"
                                      className="form-control text-right amt_will_add"
                                      readOnly
                                    />
                                  </td>
                                </tr> */}
                                <tr>
                                  <td>
                                    <strong>Surge Amount</strong>
                                  </td>
                                  <td className="text-right d-flex">
                                    <span className="mr-2">₹</span>
                                    <input
                                      min="0"
                                      name="slug_amt"
                                      type="number"
                                      id="slug_amt"
                                      value={surg}
                                      onChange={(e) => {
                                        let value = parseInt(
                                          e.target.value != 0
                                            ? e.target.value
                                            : 0
                                        );
                                        setSurg(value);
                                      }}
                                      className="form-control text-right amt_will_add"
                                    />
                                  </td>
                                </tr>

                                {otherCharges &&
                                  otherCharges?.map((item, index) => {
                                    return (
                                      <tr>
                                        <td>
                                          <strong>{item?.charge}</strong>
                                        </td>
                                        <td className="text-right d-flex">
                                          <span className="mr-2">₹</span>
                                          <input
                                            name="sef_hyg_kit"
                                            type="number"
                                            id="sef_hyg_kit"
                                            value={item?.price}
                                            onChange={(e) =>
                                              handlePriceChange(
                                                index,
                                                Number(e.target.value)
                                              )
                                            }
                                            className="form-control text-right amt_will_add"
                                          />
                                        </td>
                                      </tr>
                                    );
                                  })}
                                <tr>
                                  <td>
                                    <strong>Concession</strong>
                                  </td>
                                  <td className="text-right d-flex">
                                    <span className="mr-2">₹</span>
                                    <input
                                      name="concession"
                                      // type="tel"
                                      // id="concession"
                                      value={concession}
                                      onChange={(e) => {
                                        setConcession(e.target.value);
                                      }}
                                      className="form-control text-right amt_will_minus"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Total</strong>
                                  </td>
                                  <td className="text-right d-flex">
                                    <span className="mr-2">₹</span>
                                    <input
                                      type="tel"
                                      readOnly
                                      className="form-control text-right"
                                      id="payble_amount"
                                      name="payble_amount"
                                      value={totalAmount}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <input
                        type="hidden"
                        value="new_job"
                        name="action"
                        id="action"
                      />
                      <div className="card-body border-top">
                        <button
                          onClick={(e) => {
                            handleSubmit(e);
                          }}
                          type="submit"
                          className="btn btn-primary"
                        >
                          {loading ? (
                            <div
                              className="spinner-border text-light loader"
                              role="status"
                            >
                              <span className="sr-only">Loading...</span>
                            </div>
                          ) : (
                            <span> Update Job</span>
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <div
        className="modal fade"
        id="exampleModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Add Address
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setApartment("");
                  setLandmark("");
                  setHouse("");
                  setFullAdress("");
                  setCreateValid(false);
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <MyCustomPlacesAutocomplete
                      inputValuee={fullAdress?.length > 0 ? false : true}
                      handleOnChange={handleOnchage}
                      apiKey={myApiKey}
                      inputValue={fullAdress}
                      setInputValue={setFullAdress}
                    />
                    {/* <GooglePlacesAutocomplete
                      styles={{
                        listView: {
                          position: "absolute",
                          top: 90,
                        },
                      }}
                      enablePoweredByContainer={false}
                      autoFillOnNotFound={true}
                      enableHighAccuracyLocation={true}
                      fetchDetails={true}
                      selectProps={{
                        onChange: handleOnchage,
                      }}
                      ref={inputRef}
                      nearbyPlacesAPI="GooglePlacesSearch"
                      onFail={(error) => console.error(error)}
                      autocompletionRequest={{
                        componentRestrictions: {
                          country: ["in"],
                        },
                      }}
                      query={{
                        key: myApiKey,
                        language: "en",
                      }}
                    /> */}
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="House/Flat No"
                      value={house}
                      onChange={(e) => {
                        setHouse(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group">
                    <input
                      value={apartment}
                      onChange={(e) => {
                        setApartment(e.target.value);
                      }}
                      type="text"
                      className="form-control"
                      placeholder="Appartment/Society/Building Name"
                    />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Landmark"
                      value={landmark}
                      onChange={(e) => {
                        setLandmark(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group">
                    <label>Save As</label>
                    <br />
                    <div className="visual-picker visual-picker-sm has-peek mr-2">
                      <input
                        onChange={handleOptionChange}
                        type="radio"
                        id="vpr01"
                        name="vprSM"
                        value="Home"
                        checked={selectedOption === "Home"}
                      />
                      <label
                        className="visual-picker-figure"
                        style={{ width: "100px", height: "40px" }}
                        htmlFor="vpr01"
                      >
                        <span className="visual-picker-content">Home</span>
                      </label>
                    </div>

                    <div className="visual-picker visual-picker-sm has-peek ">
                      <input
                        onChange={handleOptionChange}
                        type="radio"
                        id="vpr02"
                        name="vprSM"
                        value="Office"
                        checked={selectedOption === "Office"}
                      />
                      <label
                        className="visual-picker-figure"
                        style={{ width: "100px", height: "40px" }}
                        htmlFor="vpr02"
                      >
                        <span className="visual-picker-content">Office</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                onClick={() => {
                  EditUserAddress();
                }}
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                aria-label="Close"
                {...(createValid && { "data-dismiss": "modal" })}
              >
                Save Address
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditJob;
